'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Tabs = exports.Tab = undefined;

var _Tab2 = require('./Tab');

var _Tab3 = _interopRequireDefault(_Tab2);

var _Tabs2 = require('./Tabs');

var _Tabs3 = _interopRequireDefault(_Tabs2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.Tab = _Tab3.default;
exports.Tabs = _Tabs3.default;
exports.default = _Tabs3.default;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui/Tabs/index.js
// module id = ./node_modules/material-ui/Tabs/index.js
// module chunks = index